<template>
  <div>
    <h2 class="step-name">Review Annual Anti-Microbial Usage (AMU)</h2>

    <div class="step-section">
      <h3>Usage in ingredient mg/kg biomass</h3>
      <span class="text-success">Green: 1st choice</span> |
      <span class="text-warning">Yellow: 2nd choice</span> |
      <span class="text-danger">Red: Last choice</span>
      <bar :chart-data="amuFiveYearsTrafficchartData" :options="chartOptions" ></bar>
    </div>

    <div class="step-section">
      <h3>Top products by total amount used (AMU in mg/kg by season)</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Product</th>
            <th>Classification</th>
            <th>{{ seasonStartYear -4 }} / {{ seasonStartYear -3 }}</th>
            <th>{{ seasonStartYear -3 }} / {{ seasonStartYear -2 }}</th>
            <th>{{ seasonStartYear -2 }} / {{ seasonStartYear -1 }}</th>
            <th>{{ seasonStartYear -1 }} / {{ seasonStartYear }}</th>
            <th>{{ seasonStartYear }} / {{ seasonStartYear + 1 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in model.CHARTS.amu_five_years_products_usage" :key="index">
            <td class="text-left">{{ rv["product"] }}</td>
            <td class="text-left alert" :class="getClassificationClass(rv['classification'])">{{ rv["classification"] }}</td>
            <td class="text-left">{{ rv["season_start_4"] }}</td>
            <td class="text-left">{{ rv["season_start_3"] }}</td>
            <td class="text-left">{{ rv["season_start_2"] }}</td>
            <td class="text-left">{{ rv["season_start_1"] }}</td>
            <td class="text-left">{{ rv["season_start"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <h3>Period to-date Anti-Microbial Usage</h3>
      <h4>Client usage and Region Average (total mg/kg)</h4>
      <span class="text-success">Green: 1st choice</span> |
      <span class="text-warning">Yellow: 2nd choice</span> |
      <span class="text-danger">Red: Last choice</span>
      <bar :chart-data="amuPeriodComparechartData" :options="chartOptions" ></bar>
    </div>

    <div class="step-section">
      <div class="form-group">
        <label for="amu_keypoints">Key Points</label>
        <textarea rows="5" cols="50" v-model="model.amu_keypoints" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>

      <div class="form-group">
        <label for="amu_actions">Actions</label>
        <textarea rows="5" cols="50" v-model="model.amu_actions" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'
import Bar from '../../charts/Bar'
import { capitalize } from '../../../_helpers'

export default {
  mixins: [ baseComponent ],
  components: {
    Bar,
  },
  data() {
    return {
      model: {
        amu_keypoints: "",
        amu_actions: "",
        CHARTS: {
          amu_five_years_products_usage: [],
          amu_five_years_traffic: [],
          amu_period_compare: [],
          amu_period_compare_bars: [],
        },
      },
    }
  },
  computed: {
    chartOptions: function () {
      return {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            categoryPercentage: 0.5,
            barPercentage: 1,
            stacked: true,
            scaleLabel: {
              display: true,
              labelString: 'mg/kg'
            }
          }],
          xAxes: [{
            stacked: true
          }]
        },
      }
    },
    amuFiveYearsTrafficchartData: function() {
      let datasets = [
        { backgroundColor: [], data: [] },
        { backgroundColor: [], data: [] },
        { backgroundColor: [], data: [] },
      ]

      this.model.CHARTS.amu_five_years_traffic.forEach(function(elem) {
        let backgrounds

        if (elem.name == 'client') {
          backgrounds = ["rgba(0, 128, 0, 1)", "rgba(255, 215, 0, 1)", "rgba(255, 0, 0, 1)"]
        } else {
          backgrounds = ["rgba(0, 128, 0, 0.4)", "rgba(255, 215, 0, 0.4)", "rgba(255, 0, 0, 0.4)"]
        }

        datasets[0].backgroundColor.push(backgrounds[0])
        datasets[1].backgroundColor.push(backgrounds[1])
        datasets[2].backgroundColor.push(backgrounds[2])

        datasets[0].data.push(elem.green)
        datasets[1].data.push(elem.orange)
        datasets[2].data.push(elem.red)
      })

      return {
        labels: this.model.CHARTS.amu_five_years_traffic.map(row => row['season'] +' '+ capitalize(row['name'])),
        datasets: datasets,
      }
    },
    amuPeriodComparechartData: function() {
      let datasets = [
        { backgroundColor: [], data: [] },
        { backgroundColor: [], data: [] },
        { backgroundColor: [], data: [] },
      ]
      this.model.CHARTS.amu_period_compare_bars.forEach(function(elem) {
        let backgrounds

        if (elem.name == 'client') {
          backgrounds = ["rgba(0, 128, 0, 1)", "rgba(255, 215, 0, 1)", "rgba(255, 0, 0, 1)"]
        } else {
          backgrounds = ["rgba(0, 128, 0, 0.4)", "rgba(255, 215, 0, 0.4)", "rgba(255, 0, 0, 0.4)"]
        }

        datasets[0].backgroundColor.push(backgrounds[0])
        datasets[1].backgroundColor.push(backgrounds[1])
        datasets[2].backgroundColor.push(backgrounds[2])

        datasets[0].data.push(elem.green)
        datasets[1].data.push(elem.orange)
        datasets[2].data.push(elem.red)
      })

      return {
        labels: this.model.CHARTS.amu_period_compare_bars.map(row => capitalize(row['name']) +' '+ row['period']),
        datasets: datasets,
      }
    },
  },
  methods: {
    getClassificationClass: function(number) {
      if (number == '1') {
        return 'alert-success'
      }
      if (number == '2') {
        return 'alert-warning'
      }
      if (number == '3') {
        return 'alert-danger'
      }
    },
  },
};
</script>
